import { AlertsStore } from '@/configs/store/AlertsStore';
import { formatError } from '@/utils/formatError';

/** Оповещение «Не удалось …» с текстом ошибки бэкенда, закрывается само */
export const showError = ({
  alertsStore,
  title,
  error,
}: {
  alertsStore: AlertsStore;
  title: string;
  error: unknown;
}): void => {
  alertsStore.addAlert({ title, message: formatError(error).message, autoClose: true });
};
